import _ from 'lodash'

const eventHandlers = {}
const defaultConfig = { closeOthers: true, expandFirst: true }

const toggleElement = (trigger, toggle, container) => {
  trigger.setAttribute('aria-expanded', !!toggle)
  const content = container.querySelector(`[id="${trigger.getAttribute('aria-controls')}"]`)
  content.setAttribute('aria-hidden', !toggle)
}

const toggleCallback = function(accordionTogglers, containerElement, config) {
  if (this.getAttribute('aria-expanded') === 'true') {
    toggleElement(this, false, containerElement)
  } else if (config.closeOthers) {
    _.forEach(accordionTogglers, toggler => {
      const toggle = toggler === this
      toggleElement(toggler, toggle, containerElement)
    })
  } else {
    toggleElement(this, true, containerElement)
  }
}

const registerEventHandlers = (containerElement, accordionTogglers, config) => {
  return _.map(accordionTogglers, element => {
    const callback = _.partial(toggleCallback, accordionTogglers, containerElement, config)
    element.addEventListener('click', callback)
    return { element, callback }
  })
}

const initialize = (containerElement, config) => {
  const accordionTogglers = containerElement.querySelectorAll('.js-accordion-toggler')
  if (accordionTogglers.length === 0) {
    return
  }

  if (config.expandFirst) {
    const firstToggler = accordionTogglers.item(0)
    toggleElement(firstToggler, true, containerElement)
  }

  eventHandlers[containerElement] = registerEventHandlers(containerElement, accordionTogglers, config)
}

const unbind = (containerElement) => {
  _.forEach(eventHandlers[containerElement], ({ element, callback }) => {
    element.removeEventListener('click', callback)
  })
}

const directive = {
  bind(containerElement, binding) {
    const config = _.merge({}, defaultConfig, _.get(binding, 'value'))
    if(_.isUndefined(config.mediaQuery) || config.mediaQuery) {
      initialize(containerElement, config)
    } else if(config.mediaQuery === false) {
      unbind(containerElement)
    }
  },
  unbind
}

export default directive
